import React from 'react';
import { Sun, Cloud, CloudSun, CloudRain, CloudSnow, CloudLightning, CloudFog, Wind, Droplets, MapPin } from 'lucide-react';

function iconFor(code) {
  if (code === 0) return Sun;
  if (code === 1) return CloudSun;
  if (code === 2) return CloudSun;
  if (code === 3) return Cloud;
  if (code >= 45 && code <= 48) return CloudFog;
  if (code >= 51 && code <= 67) return CloudRain;
  if (code >= 71 && code <= 77) return CloudSnow;
  if (code >= 80 && code <= 82) return CloudRain;
  if (code >= 95) return CloudLightning;
  return CloudSun;
}

export default function WeatherWidget({ data = [] }) {
  const list = data || [];
  const primary = list[0];
  const PrimaryIcon = primary ? iconFor(primary.code) : Sun;

  return (
    <div className="rounded-xl overflow-hidden border border-[#e3ece7] bg-white shadow-sm">
      <div className="px-4 py-3 flex items-center justify-between text-white" style={{ background: 'linear-gradient(135deg, #157347, #0b3d26)' }}>
        <span className="font-cond font-bold uppercase tracking-wider text-sm">Michigan Weather</span>
        <span className="text-[11px] text-[#cdeddb]">Live</span>
      </div>

      {primary && (
        <div className="px-4 py-4 border-b border-[#eef2f0] bg-[#f7fbf9]">
          <div className="flex items-center justify-between">
            <div>
              <div className="inline-flex items-center gap-1 text-[13px] font-semibold text-[#0f5132]"><MapPin className="w-3.5 h-3.5" />{primary.city}</div>
              <div className="text-4xl font-bold text-[#14241d] mt-1">{Math.round(primary.temp)}°<span className="text-lg font-medium text-[#5b6b63]">F</span></div>
              <div className="text-sm text-[#5b6b63]">{primary.condition}</div>
            </div>
            <PrimaryIcon className="w-16 h-16 text-[#2e9e6b]" strokeWidth={1.4} />
          </div>
          <div className="flex items-center gap-4 mt-3 text-[12px] text-[#5b6b63]">
            <span className="inline-flex items-center gap-1"><Wind className="w-3.5 h-3.5" />{primary.wind} mph</span>
            <span className="inline-flex items-center gap-1"><Droplets className="w-3.5 h-3.5" />{primary.humidity}%</span>
            <span>H {Math.round(primary.high)}° / L {Math.round(primary.low)}°</span>
          </div>
        </div>
      )}

      <ul className="divide-y divide-[#eef2f0]">
        {list.slice(1).map((w) => {
          const Icon = iconFor(w.code);
          return (
            <li key={w.city} className="px-4 py-2.5 flex items-center justify-between hover:bg-[#f7fbf9] transition-colors">
              <span className="inline-flex items-center gap-2 text-sm text-[#14241d]">
                <Icon className="w-5 h-5 text-[#2e9e6b]" strokeWidth={1.6} />
                {w.city}
              </span>
              <span className="text-sm">
                <span className="font-semibold text-[#14241d]">{Math.round(w.temp)}°</span>
                <span className="text-[#9aa8a1] ml-2 text-xs">{Math.round(w.high)}°/{Math.round(w.low)}°</span>
              </span>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
